module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-sponsors-wrapper",
    class: [{
      'is-alt': _vm.isAlt === 'true'
    }]
  }, [(_vm.isAlt === 'true' && _vm.isDesktop) ? _c('div', {
    staticClass: "background"
  }, [_c('img', {
    staticClass: "object",
    attrs: {
      "src": require("../assets/car.svg")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-sub-sponsors",
    attrs: {
      "id": "section-sub-sponsors",
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "title": _vm.title ? _vm.title : _vm.paragraph.title,
      "text-align": (_vm.level === '0' ? 'left' : 'center'),
      "title-style": [_vm.level === '0' && _vm.index !== '1' ? {} : {
        borderBottom: '0px'
      }]
    }
  }), _vm._v(" "), _c('div-container', [(_vm.level !== '0') ? _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "column has-text-left content-images",
      class: {
        'is-3 is-6-mobile': true
      }
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.image.path
      }
    })])])
  }), 0) : _c('div-columns', {
    attrs: {
      "paddingTop": "1rem",
      "paddingBottom": "0"
    }
  }, [_c('div', {
    class: [(_vm.isLimitContent ? 'level-0-content' : '')],
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])], 1)], 1), _vm._v(" "), (_vm.isAlt === 'true' && !_vm.isDesktop) ? _c('div', {
    staticClass: "section-sub-sponsors",
    staticStyle: {
      "text-align": "right",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "object",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "src": require("../assets/car.svg")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93b2e6de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SponsorsSubSection.vue
// module id = 925
// module chunks = 1